import { render } from "./Command.vue?vue&type=template&id=18b39f58&scoped=true"
import script from "./Command.vue?vue&type=script&lang=js"
export * from "./Command.vue?vue&type=script&lang=js"

import "./Command.vue?vue&type=style&index=0&id=18b39f58&scoped=true&lang=css"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b39f58"]])

export default __exports__